<template>
  <model-form
    :model="siteSchedule"
  >
    <div class="column">
      <div class="row q-col-gutter-sm items-start">
        <q-input
          v-model="siteSchedule.name"
          class="col-6"
          label="Name"
          :rules="[val => !!val || 'Field is required']"
          bottom-slots
          :autofocus="!$q.platform.is.ios"
        />
        <iso-date-input
          v-model="siteSchedule.startDate"
          class="col-3"
          label="Start Date"
          emit-string="nullify-blank"
          :rules="startDateRules"
          clearable
        />
        <iso-date-input
          v-model="siteSchedule.endDate"
          class="col-3"
          label="End Date"
          emit-string="nullify-blank"
          :rules="endDateRules"
          clearable
        />
      </div>
      <site-schedule v-model="siteSchedule.schedule" />
    </div>
  </model-form>
</template>

<script>
import IsoDateInput from 'src/modules/admin/components/IsoDateInput'
import ModelForm from 'src/modules/admin/components/ModelForm/ModelForm'
import SiteSchedule from 'src/modules/admin/site-schedule/SiteSchedule'

export default {
  name: 'SiteScheduleForm',
  components: {
    IsoDateInput,
    ModelForm,
    SiteSchedule
  },
  computed: {
    startDateRules () {
      return [
        // Validate presence
        startDate => {
          if (!startDate && !this.siteSchedule.endDate) {
            return true
          } else if (startDate) {
            return true
          } else {
            return 'Start Date is required if End Date is set'
          }
        },
        // Validate order
        () => {
          // Compare the start date from the model instead of from the input
          // because the input string will be in localized string format (e.g. 'DD/MM/YYYY')
          // whereas the model will be in ISO format (e.g. 'YYYY-MM-DD')
          if (!this.siteSchedule.startDate || !this.siteSchedule.endDate) {
            return true
          } else if (this.siteSchedule.startDate <= this.siteSchedule.endDate) {
            return true
          } else {
            return 'Start Date must be before End Date'
          }
        }
      ]
    },
    endDateRules () {
      return [
        // Validate presence
        endDate => {
          if (!endDate && !this.siteSchedule.startDate) {
            return true
          } else if (endDate) {
            return true
          } else {
            return 'End Date is required if Start Date is set'
          }
        },
        // Validate order
        () => {
          // Compare the end date from the model instead of from the input
          // because the input string will be in localized string format (e.g. 'DD/MM/YYYY')
          // whereas the model will be in ISO format (e.g. 'YYYY-MM-DD')
          if (!this.siteSchedule.endDate || !this.siteSchedule.startDate) {
            return true
          } else if (this.siteSchedule.endDate >= this.siteSchedule.startDate) {
            return true
          } else {
            return 'End Date must be after Start Date'
          }
        }
      ]
    }
  },
  models: {
    siteSchedule: 'default'
  }
}

</script>
